module.exports = __webpack_public_path__ + "img/g-play.70361dbb.svg";